import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useCallback, useMemo, useState } from 'react';
import { Modals, useModalMethods } from 'src/store/modals';
import { PlatformUserRaw } from 'src/types';

export const UsersActionsMenu = ({
  onCreateUser,
  partnerId,
}: {
  onCreateUser: (data: Partial<PlatformUserRaw>) => void;
  partnerId: number | null;
}) => {
  const { showModal } = useModalMethods(Modals.CreateUser);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = useMemo(() => !!anchorEl, [anchorEl]);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCreateUser = useCallback(() => {
    handleClose();
    showModal({
      onSubmit: onCreateUser,
      partnerId,
    });
  }, [showModal, onCreateUser, partnerId]);

  return (
    <Box>
      <Button
        id="user-actions-menu"
        aria-controls={open ? 'user-actions-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleMenuOpen}
      >
        Menu
      </Button>
      <Menu
        id="user-actions-menu"
        aria-labelledby="user-actions-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem onClick={handleCreateUser}>Create User</MenuItem>
      </Menu>
    </Box>
  );
};
